import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LanguageIcon from '@mui/icons-material/Language';
import SmartphoneIcon from '@mui/icons-material/Smartphone';

export default [{ path: '/', label: 'home', Icon: HomeRoundedIcon },
  { path: '/mobile-apps', label: 'projectMobile', Icon: SmartphoneIcon },
  { path: '/web-sites', label: 'projectWeb', Icon: LanguageIcon }];
